import React, { useState, useEffect, useMemo, useCallback } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "../../components/MDBox";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDTypography from "../../components/MDTypography";
import Card from "@mui/material/Card";
import MDInput from "../../components/MDInput";
import UBKDate from "../../components/UBKDate";
import UBKfile from "../../components/UBKfile";
import { ConfigFile } from "../../services/ConfigFile";
import dayjs from "dayjs";
import toast, { Toaster } from "react-hot-toast";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { Button } from "antd";
import { Table } from "antd";
import IconButton from "@mui/material/IconButton";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { getNewData, addDataTigget, updateData } from "../../Api/api";
import { Input } from "antd";
import Modal from "@mui/material/Modal";
import MDButton from "../../components/MDButton";
import UBKRadio from "../../components/UBKRadio";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate } from "react-router-dom";
import { AmountFormat } from "../../services/TextChangeGlobal";
import { Spin } from "antd";

import { Popconfirm } from "antd";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
};

function Billing() {
  const path = ConfigFile.BaseUrl;
  const [openModule, setOpenModule] = useState(false);
  const [img, setImage] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowValue, setSelectedRowValue] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingLink, setLoadingLink] = useState(false);
  const [uploadUrl, setUploadUrl] = useState("");
  const [parcially, setParcialy] = useState(false);
  const { TextArea } = Input;

  const [isBusy, setIsbusy] = useState(false);
  const [paynemtLink, setPaymentLink] = useState("");
  const [linkopen, setLinlopen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  // --- safe local storage parse ---
  const safeParseUser = () => {
    try {
      const raw = localStorage.getItem("userdata");
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (err) {
      console.error("Failed parsing userdata:", err);
      return null;
    }
  };
  const jsonString = safeParseUser() || {};
  const { id: admin_id, email_id, first_name, phone } = jsonString;
  const adminid = admin_id;

  const navigate = useNavigate();
  const [tableParams, setTableParams] = useState({
    pagination: { current: 1, pageSize: 10 },
  });

  const [studentData, setStudentData] = useState({
    admin_id: adminid,
    recipt_id: "",
    receipt_type: "",
    payment_type: "",
    recived_payment: 0,
    amount: 0,
    admission_id: "",
    discount: 0,
  });

  // SWR fetch for list
  const swrKey = `/superAdmin/getSchoolDetailsByAdminId?id=${adminid}&page=${tableParams.pagination.current}&per_page=${tableParams.pagination.pageSize}`;
  const { data: newData, isLoading, error, mutate } = useSWR(swrKey, getNewData);

  // Mutation hooks
  const { trigger: triggerUpload, isMutating: isUploading } = useSWRMutation(
    uploadUrl,
    addDataTigget
  );
  const { trigger: razerpayPost } = useSWRMutation("/admin/Admin/payonline", addDataTigget);
  const { trigger: paymentLink } = useSWRMutation("/admin/Admin/paymentLink", addDataTigget);
  const { trigger: afterpayment } = useSWRMutation("/admin/Admin/paymentVerify", addDataTigget);

  // =========== Helpers =============
  const computeTotalFromRows = useCallback((rows) => {
    return rows.reduce((acc, r) => acc + Number(r?.amount ?? 0), 0);
  }, []);

  // Row selection handlers
  const onRowSelectionChange = useCallback(
    (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRowValue(selectedRows);
      setTotalAmount(computeTotalFromRows(selectedRows));
    },
    [computeTotalFromRows]
  );

  const rowSelection = useMemo(
    () => ({
      selectedRowKeys,
      onChange: onRowSelectionChange,
      onSelect: (record, selected, selectedRows) => {
        // onSelect still recomputes using selectedRows for safety
        setTotalAmount(computeTotalFromRows(selectedRows));
      },
      onSelectAll: (selected, selectedRows) => {
        setTotalAmount(selected ? computeTotalFromRows(selectedRows) : 0);
      },
    }),
    [selectedRowKeys, onRowSelectionChange, computeTotalFromRows]
  );

  // Memoized columns to avoid re-creation every render
  const columns = useMemo(
    () => [
      { title: "Branch Name", dataIndex: "branch_name", key: "branch_name" },
      { title: "Phone No", dataIndex: "conatct_number", key: "conatct_number" },
      { title: "Start Date", dataIndex: "start_date", key: "start_date" },
      { title: "Total Student", dataIndex: "total_student", key: "total_student" },
      {
        title: "Per Student Cost",
        dataIndex: "per_student_cost",
        align: "right",
        render: (item) => <div style={{ fontSize: 11 }}>{AmountFormat(item)}</div>,
      },
      {
        title: "Agent Commission / Month %",
        dataIndex: "admin_commission",
        align: "right",
        render: (item) => <div style={{ fontSize: 11 }}>{item}</div>,
      },
      { title: "Status", dataIndex: "status", key: "status" },
    ],
    []
  );

  const paid_columns = useMemo(
    () => [
      {
        title: "Invoice No",
        dataIndex: "fees_name",
        render: (item, record) => <div style={{ fontSize: 11 }}>{record?.receipt_no}</div>,
      },
      {
        title: "Date",
        key: "receipt_date",
        render: (item, record) => (
          <div style={{ fontSize: 11 }}>
            <div className="label label-success">{record?.monthly_schedule_payment_date}</div>
          </div>
        ),
      },
      {
        title: "Amount",
        key: "amount",
        dataIndex: "paid_amount",
        render: (item, record) => (
          <div style={{ fontSize: 11 }}>
            <div>Paid : {AmountFormat(record.recived_amount)}</div>
          </div>
        ),
      },
      {
        title: "Status",
        dataIndex: "status",
        render: (item, record) => {
          return (
            <div style={{ fontSize: 11 }}>
              {record.status === "partial" ? (
                <div style={{ display: "flex", gap: 8 }}>
                  <span
                    onClick={() =>
                      handleOpenPartiallyMonth(
                        record.id,
                        Number(Number(record.main_amount) - Number(record.payment_amount))
                      )
                    }
                    style={{ cursor: "pointer" }}
                    className="label label-danger"
                  >
                    Partially Paid
                  </span>
                  <div>
                    Due Amount :{" "}
                    {AmountFormat(Number(record.main_amount) - Number(record.payment_amount))}
                  </div>
                </div>
              ) : record.status === "paid" ? (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span className="label label-success">
                    {record.Fees_info === "Partially Paid" ? "Partially Paid" : "Paid"}
                  </span>
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={() =>
                      handlePrintIconClick(
                        record,
                        record.Fees_info === "Partially Paid" ? "Partially" : "feesmaster"
                      )
                    }
                  >
                    <PrintIcon sx={{ color: "#3892ee" }} fontSize="small" />
                  </IconButton>
                </div>
              ) : null}
            </div>
          );
        },
      },
    ],
    []
  );

  // Expanded row renderer (memoized)
  const expandedRowRender = useCallback(
    (mainRecord) => {
      const pendingColumns = [
        { title: "Date", dataIndex: "payment_month", key: "payment_month" },
        {
          title: "Amount",
          dataIndex: "amount",
          render: (item) => <div style={{ fontSize: 11 }}>{AmountFormat(item)}</div>,
        },
        { title: "Status", dataIndex: "status", key: "state" },
      ];

      return (
        <>
          <div style={{ display: "flex", width: "100%", height: 50 }}>
            {mainRecord?.payments?.paid?.length ? (
              <div
                style={{
                  flex: 1,
                  border: "1px solid",
                  fontSize: 14,
                  fontWeight: "bold",
                  padding: 13,
                }}
              >
                <span>Paid Payment</span>
              </div>
            ) : null}
            {mainRecord?.payments?.pending?.length ? (
              <div
                style={{
                  flex: 1,
                  border: "1px solid",
                  fontSize: 14,
                  fontWeight: "bold",
                  padding: 13,
                }}
              >
                <span>Upcoming Payment</span>
              </div>
            ) : null}
          </div>

          <div style={{ display: "flex", gap: 8 }}>
            {mainRecord?.payments?.paid?.length ? (
              <div style={{ flex: 1, border: "1px solid" }}>
                <Table
                  columns={paid_columns}
                  pagination={false}
                  dataSource={mainRecord?.payments?.paid}
                  rowKey={(r) => r?.id}
                />
              </div>
            ) : null}

            {mainRecord?.payments?.pending?.length ? (
              <div style={{ flex: 1, border: "1px solid" }}>
                <Table
                  columns={pendingColumns}
                  rowSelection={rowSelection}
                  dataSource={mainRecord?.payments?.pending}
                  rowKey={(r) => r.payment_month}
                  pagination={false}
                />
              </div>
            ) : null}
          </div>
        </>
      );
    },
    [paid_columns, rowSelection]
  );

  // ---------- Event handlers ----------
  const handleOpenPartiallyMonth = (recipt_id, amount) => {
    setLoading(true);
    setOpenModule(true);
    setParcialy(true);
    setUploadUrl("/superAdmin/payingMonthlyPayment_____2");
    setStudentData((prev) => ({ ...prev, recipt_id, discount: 0, recived_payment: 0, amount }));
    setLoading(false);
  };

  const handlePrintIconClick = (record, type) => {
    localStorage.setItem("receipt_id", record.id);
    navigate(`/invoicePage?receipt_id=${record.id}&type=invoice`);
  };

  const getCallbackSingle = (action) => (event) => {
    if (event && event[0]?.status === "done") {
      const name = event[0].response.data;
      setImage(name);
    }
  };

  const handleFChange = (e) => {
    const { name, value } = e.target;
    setStudentData((prev) => {
      const next = { ...prev, [name]: value };
      // recalc parcially if recived_payment < amount - discount
      if (name === "recived_payment" || name === "discount") {
        const discount = Number(next.discount || 0);
        const amount = Number(next.amount || 0);
        const recived = Number(next.recived_payment || 0);
        next.isPartial = recived < amount - discount;
        setParcialy(next.isPartial);
      }
      return next;
    });
  };

  // safer payment verify wrapper
  const paymentVerify = useCallback(
    async (response) => {
      try {
        if (!response) {
          console.warn("No response to verify");
          return;
        }
        setLoading(true);
        const result = await afterpayment(response);
        // refresh list after verifying
        await mutate();
        setIsbusy(false);

        setLoading(false);
        return result;
      } catch (err) {
        console.error("paymentVerify error:", err);
        setLoading(false);
        throw err;
      }
    },
    [afterpayment, mutate]
  );

  const loadRazorpay = async (src) => {
    return new Promise((resolve) => {
      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) {
        existing.onload ? resolve(true) : resolve(true);
        return;
      }
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const submitAllData = useCallback(async () => {
    if (!selectedRowValue || selectedRowValue.length === 0) {
      toast.error("No rows selected");
      return;
    }
    setLoading(true);
    try {
      const loaded = await loadRazorpay("https://checkout.razorpay.com/v1/checkout.js");
      if (!loaded) {
        toast.error("Failed to load Razorpay SDK");
        setLoading(false);

        return;
      }

      // call server to create order / get order id
      const payload = {
        amount: Number(totalAmount),
        admin_id: adminid,
        data: JSON.stringify(selectedRowValue),
      };
      const result = await razerpayPost(payload);

      // result.id assumed to be razorpay order id; result.amount may be in rupees or paise depending on backend.
      // Make intention explicit: treat result.amount as |INR| (rupees) if your backend returns rupees; if it returns paise, adjust accordingly.
      if (!result || !result.id) {
        toast.error("Failed to initiate payment. No order returned.");
        setLoading(false);
        return;
      }

      setIsbusy(true);

      // If your backend returns amount in paise use: const amountInPaise = Number(result.amount);
      // If it returns in rupees use totalAmount * 100
      // I will assume backend returned amount in rupees (same unit you used to send request).
      const amountInPaise = Number(totalAmount) * 100;

      const options = {
        key: "rzp_test_RbDBmf9YGnyNHx", // test key — replace with env var in production
        amount: amountInPaise,
        currency: "INR",
        name: "UBK INFOTECH PVT LTD",
        order_id: result.id,
        description: "UBK ERP",
        handler: async function (response) {
          try {
            await paymentVerify(response);
            toast.success("Payment successful");
            // after verification server should mark invoices paid
            setSelectedRowKeys([]);
            setSelectedRowValue([]);
            setTotalAmount(0);
          } catch (err) {
            toast.error("Payment verification failed");
            console.error(err);
          }
        },
        prefill: {
          name: first_name || "",
          email: email_id || "",
          contact: phone || "",
        },
        theme: { color: "#3399cc" },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (err) {
      console.error("submitAllData error:", err);
      toast.error("Payment initiation failed");
    } finally {
      setLoading(false);
    }
  }, [
    selectedRowValue,
    totalAmount,
    adminid,
    razerpayPost,
    paymentVerify,
    first_name,
    email_id,
    phone,
  ]);

  const createAllData = useCallback(async () => {
    setLoadingLink(true)
    if (!selectedRowValue || selectedRowValue.length === 0) {
      toast.error("No rows selected");
      return;
    }
    //setLoading(true);

    try {
      const payload = {
        amount: Number(totalAmount),
        admin_id: adminid,
        data: JSON.stringify(selectedRowValue),
      };
      const result = await paymentLink(payload);

      console.log("result___________", result.short_url);
      setPaymentLink(result.short_url);
      setLinlopen(true);
      setLoadingLink(false)
    } catch (err) {}

    // try {
    //   const loaded = await loadRazorpay("https://checkout.razorpay.com/v1/checkout.js");
    //   if (!loaded) {
    //     toast.error("Failed to load Razorpay SDK");
    //     setLoading(false);

    //     return;
    //   }

    //   // call server to create order / get order id
    //   const payload = { amount: Number(totalAmount), admin_id: adminid, data: JSON.stringify(selectedRowValue) };
    //   const result = await razerpayPost(payload);

    //   // result.id assumed to be razorpay order id; result.amount may be in rupees or paise depending on backend.
    //   // Make intention explicit: treat result.amount as |INR| (rupees) if your backend returns rupees; if it returns paise, adjust accordingly.
    //   if (!result || !result.id) {
    //     toast.error("Failed to initiate payment. No order returned.");
    //     setLoading(false);
    //     return;
    //   }

    //setIsbusy(true);

    // If your backend returns amount in paise use: const amountInPaise = Number(result.amount);
    // If it returns in rupees use totalAmount * 100
    // I will assume backend returned amount in rupees (same unit you used to send request).
    //   const amountInPaise = Number(totalAmount) * 100;

    //   const options = {
    //     key: "rzp_test_RbDBmf9YGnyNHx", // test key — replace with env var in production
    //     amount: amountInPaise,
    //     currency: "INR",
    //     name: "UBK INFOTECH PVT LTD",
    //     order_id: result.id,
    //     description: "UBK ERP",
    //     handler: async function (response) {
    //       try {
    //         await paymentVerify(response);
    //         toast.success("Payment successful");
    //         // after verification server should mark invoices paid
    //         setSelectedRowKeys([]);
    //         setSelectedRowValue([]);
    //         setTotalAmount(0);
    //       } catch (err) {
    //         toast.error("Payment verification failed");
    //         console.error(err);
    //       }
    //     },
    //     prefill: {
    //       name: first_name || "",
    //       email: email_id || "",
    //       contact: phone || "",
    //     },
    //     theme: { color: "#3399cc" },
    //   };

    //   const paymentObject = new window.Razorpay(options);
    //   paymentObject.open();
    // } catch (err) {
    //   console.error("submitAllData error:", err);
    //   toast.error("Payment initiation failed");
    // } finally {
    //   setLoading(false);
    // }
  }, [
    selectedRowValue,
    totalAmount,
    adminid,
    razerpayPost,
    paymentVerify,
    first_name,
    email_id,
    phone,
  ]);

  const handleSub = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        setLoading(true);
        const formData = new FormData(e.target);
        formData.append("admin_id", studentData.admin_id);
        formData.append("main_amount", Number(studentData.amount));

        let updated_amount = 0;
        if (studentData.recived_payment) {
          updated_amount = Number(studentData.recived_payment) - Number(studentData.discount || 0);
        } else {
          updated_amount = Number(studentData.amount) - Number(studentData.discount || 0);
        }
        formData.append("amount", updated_amount);
        formData.append("discount", studentData.discount || 0);
        formData.append("data", JSON.stringify(selectedRowValue));

        // convert formData to plain object for addDataTigget (your helper expects object)
        const object = {};
        formData.forEach((v, k) => (object[k] = v));

        const result = await triggerUpload(object);

        // re-fetch the list
        await mutate();

        if (result?.Status === "Success") {
          toast.success("Success! Payment..", { duration: 2000, icon: "🚀" });
        } else {
          toast.error("Payment Failed..");
        }

        // reset UI state
        setSelectedRowKeys([]);
        setSelectedRowValue([]);
        setTotalAmount(0);
        setOpenModule(false);
      } catch (err) {
        console.error("handleSub error:", err);
        toast.error("Unable to submit payment");
      } finally {
        setLoading(false);
      }
    },
    [studentData, selectedRowValue, triggerUpload, mutate]
  );

  const copyText = async () => {
   

    if (!paynemtLink) return alert("Nothing to copy!");
    try {
      await navigator.clipboard.writeText(paynemtLink);
     // alert("Copied: " + paynemtLink);
       setLinlopen(false);
    } catch (err) {
      alert("Failed to copy");
    }
  };

  const showPopconfirm = () => {
    setLinlopen(false);
  };
  

  // ---------------------------------
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Toaster toastOptions={{ position: "top-center" }} />

      <MDBox pt={8} pb={1}>
        <Modal open={openModule} onClose={() => setOpenModule(false)}>
          <MDBox>
            <Grid item xs={12} sx={style}>
              <Card>
                <MDBox p={3}>
                  <form onSubmit={handleSub}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <MDTypography variant="h5">Payment Options</MDTypography>
                        <Grid mt={1} container justifyContent={"space-between"}>
                          <UBKRadio
                            defaultValue="Cash"
                            required
                            options={[
                              { value: "Cash", label: "Cash" },
                              { value: "UPI", label: "UPI" },
                              { value: "DD", label: "DD" },
                              { value: "Bank", label: "Bank" },
                              { value: "Internet Banking", label: "Internet Banking" },
                              { value: "Cheque", label: "Cheque" },
                            ]}
                            name="payment_type"
                            label="Pay"
                          />
                        </Grid>

                        <Grid mt={1} container>
                          <Grid item xs={6}>
                            <label className="labelfont">Note</label>
                            <TextArea rows={4} placeholder="Note" name="notes" />
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            style={{
                              display: "grid",
                              alignItems: "center",
                              justifyContent: "center",
                              marginTop: 20,
                            }}
                          >
                            <UBKfile
                              url={`${path}/branchapi/frontoffice/uploadfrontofficeDocument`}
                              numberImage={1}
                              oldImage=""
                              parentCallback={getCallbackSingle()}
                            />
                            <MDInput
                              className="noDisplay"
                              type="text"
                              name="attchement"
                              defaultValue={img || ""}
                            />
                          </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ marginTop: 16 }}>
                          <Grid item xs={3}>
                            {true && (
                              <MDInput
                                defaultValue={
                                  Number(studentData.recived_payment) || Number(studentData.amount)
                                }
                                type="number"
                                name="recived_payment"
                                label="Recived Amount"
                                min="0"
                                max={Number(studentData.amount)}
                                onChange={handleFChange}
                              />
                            )}
                          </Grid>
                          <Grid item xs={3}>
                            <MDInput
                              value={studentData.discount}
                              type="number"
                              step="0.01"
                              name="discount"
                              label="Discount"
                              onChange={handleFChange}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <UBKDate
                              defaultValue={dayjs()}
                              format={"YYYY-MM-DD"}
                              name="receipt_date"
                              Desplay="Date"
                            />
                          </Grid>
                          {parcially ? (
                            <Grid item xs={3}>
                              <UBKDate
                                defaultValue={dayjs()}
                                format={"YYYY-MM-DD"}
                                name="next_due_date"
                                Desplay="Next Due Date"
                              />
                            </Grid>
                          ) : null}
                        </Grid>

                        <Grid
                          container
                          sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}
                        >
                          <MDButton
                            type="submit"
                            variant="gradient"
                            color="info"
                            size="small"
                            disabled={loading || isUploading}
                          >
                            <span style={{ color: "lightgreen" }}>
                              {Number(studentData.recived_payment) === 0
                                ? Number(studentData.amount) - Number(studentData.discount || 0)
                                : Number(studentData.recived_payment) -
                                  Number(studentData.discount || 0)}
                            </span>
                            <span
                              style={{
                                display: "inline-block",
                                borderLeft: "2px solid white",
                                height: "100%",
                                margin: 10,
                              }}
                            />
                            Collect
                          </MDButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </MDBox>
              </Card>
            </Grid>
          </MDBox>
        </Modal>

        <Spin spinning={isBusy} tip="Please wait..." size="large">
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={1}
                  px={1}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Admin List
                  </MDTypography>
                </MDBox>

                {!isLoading && newData?.admin?.[0] && (
                  <MDBox pt={1} style={{ textAlign: "center" }}>
                    {newData.admin[0].name} {newData.admin[0].company_name}{" "}
                    {newData.admin[0].start_date}
                  </MDBox>
                )}

                <MDBox p={1} m={1}>
                  {!isLoading ? (
                    <>
                      <Button
                        style={{ float: "right" }}
                        type="primary"
                        onClick={submitAllData}
                        disabled={!selectedRowKeys.length || loading}
                      >
                        {`Pay Now `} {AmountFormat(totalAmount)}
                      </Button>

                      <div style={{ float: "right", marginRight: "10px" }}>
                        {/* <Button
                          style={{ float: "right", marginRight: "10px" }}
                          type="primary"
                          onClick={createAllData}
                          disabled={!selectedRowKeys.length || loading}
                        >
                          {` Create Link `} {totalAmount}
                        </Button> */}
                        <Popconfirm
                          title="Copy Link"
                          description={paynemtLink}
                          open={linkopen}
                          onConfirm={copyText}
                          //okButtonProps={{ loading: confirmLoading }}
                           onCancel={showPopconfirm}
                        >
                          <Button disabled={!selectedRowKeys.length || loading} 
                          loading={loadingLink}
                          iconPosition="end"
                          type="primary"
                           onClick={createAllData}
                          >
                            Create Link {AmountFormat(totalAmount)}
                          </Button>
                        </Popconfirm>

                        {/* <div onClick={copyText}>{paynemtLink}</div> */}
                      </div>

                      <Table
                        style={{ margin: 0 }}
                        columns={columns}
                        expandable={{ expandedRowRender }}
                        dataSource={newData?.data}
                        rowKey={(record) => record?.branch_id}
                      />
                    </>
                  ) : (
                    <>Loading...</>
                  )}
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </Spin>
      </MDBox>
    </DashboardLayout>
  );
}

export default Billing;
